<div class="container">
    <div class="row d-flex justify-content-center">
        <div class="card px-4 mt-4" style="width: 18rem;" *ngFor="let pizza of pizzas">
          <img [src]="pizza.imgUrl" />
          <div class="card-body">
            <h5 class="card-title text-center">{{ pizza.name }}
              <span class="badge bg-warning">{{ pizza.badge }}</span>
              <span class="badge bg-success">{{ pizza.badgeGreen }}</span>
              <span class="badge bg-danger">{{ pizza.badgeRed }}</span>
            </h5>
            <p class="card-text text-center">{{ pizza.ingredients }}</p>
          </div>
            <div class="card-footer mt-auto">
            <h6 class="text-center">From {{ pizza.price | currency:'EUR' }}</h6>
            <div class="col text-center">
              <button type="button" class="btn pizza-btn" data-toggle="modal" data-target="#exampleModalCenter" (click) = "selectItem(pizza)">
                Order
              </button>
            </div>
          </div>
        </div>
        <div class="card px-4 mt-4" style="width: 18rem;">
          <img src="assets/img/pizza-create-your-own.png" />
          <div class="card-body">
            <h5 class="card-title text-center">Create your own</h5>
          </div>
          <div class="card-footer mt-auto">
            <h6 class="text-center">From €3.00</h6>
            <div class="col text-center">
              <form action="createpizza">
              <button type="button" class="btn pizza-btn" input type="submit">
                Order
              </button>
            </form>
            </div>
          </div>
        </div>
      </div>
</div>

<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" *ngIf="selectedItem">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="close pizza-close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <img [src]="selectedItem.imgUrl" />
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ selectedItem.name }}</h5>

<!-- Display price -->
<div>
  <p class="font-weight-bold text-center">Price: {{ totalPrice.toFixed(2) }}€</p>
</div>
<!-- Display price end -->

      </div>
      <div class="modal-header">
        <h6 class="modal-title">{{ selectedItem.ingredients }}</h6>
      </div>
      
      <div class="modal-body">
            <!-- Radio buttons for Size -->
          <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
            <div class="input-group-btn" data-toggle="buttons">

              <label class="btn pizza-btn pizza-radio-btn" for="small">
                <input type="radio" name="size"  id="small" (change)="onToggleSmall()" value="small" autocomplete="off">Small 18cm
              </label>
              <label class="btn pizza-btn active pizza-radio-btn" for="medium">
                <input type="radio" name="size"  id="medium" (change)="onToggleMedium()" value="medium" autocomplete="off"checked>Medium 28cm
              </label>
              <label class="btn pizza-btn pizza-radio-btn" for="large">
                <input type="radio" name="size"  id="large" (change)="onToggleLarge()" value="large" autocomplete="off">Large 38cm
              </label>
            </div>
          </div>
            <!-- Radio buttons end -->

          </div>
          <div class="modal-body">
          <button type="button" (click)="minus()" class="btn pizza-btn"><i class="fa fa-minus"></i></button>
          <input type="text" [value]="quantity" class="pizza-input">
          <button type="button" (click)="plus()" class="btn pizza-btn"><i class="fa fa-plus"></i></button>
          </div>

      <div class="modal-footer" *ngIf="selectedItem">
        <div *ngIf="message">Pizza added to cart. 
          <button type="button" class="btn pizza-btn" data-dismiss="modal" aria-label="Close" (click)="goToCart()">
            Go to cart
          </button>
        </div>
        <button type="button" class="btn pizza-btn" (click)="addToCart(selectedItem)">Add to cart</button>
      </div>
    </div>
  </div>
</div>